<template>
  <el-dialog :close-on-click-modal="false" title="Sim卡详情" :visible="detailFormVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="基本信息" name="basicInformation">
          <el-col :span="12">
            <el-form-item label="营业商信息：" :label-width="formLabelWidth" prop="operatorType">
              <label  v-text="detailForm.businessName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐类型：" :label-width="formLabelWidth" prop="packageType">
              <label v-text="detailForm.packageType"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="流量(Mb)：" :label-width="formLabelWidth" prop="flow">
              <label v-text="detailForm.flow"></label>
            </el-form-item>
          </el-col>
          <!--              <el-col :span="12">-->
          <!--                <el-form-item label="通话时长：" :label-width="formLabelWidth" prop="callDuration">-->
          <!--                  <label v-text="detailForm.callDuration"></label>-->
          <!--                </el-form-item>-->
          <!--              </el-col>-->
          <!--              <el-col :span="12">-->
          <!--                <el-form-item label="短信条数：" :label-width="formLabelWidth" prop="smsCount">-->
          <!--                  <label v-text="detailForm.smsCount"></label>-->
          <!--                </el-form-item>-->
          <!--              </el-col>-->
          <el-col :span="12">
            <el-form-item label="卡号：" :label-width="formLabelWidth" prop="cardNo">
              <label v-text="detailForm.cardNo"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorName">
              <label v-text="detailForm.operatorName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站名称：" :label-width="formLabelWidth" prop="pileName">
              <label v-text="detailForm.stationName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="桩名称：" :label-width="formLabelWidth" prop="stationName">
              <label v-text="detailForm.pileName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效日期：" :label-width="formLabelWidth" prop="validityPeriod">
              <label v-text="detailForm.validityPeriod"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="临近有效期的通知手机号码：" :label-width="formLabelWidth" prop="phone">
              <label v-text="detailForm.phone"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="临近有效期的通知邮箱：" :label-width="formLabelWidth" prop="email">
              <label v-text="detailForm.email"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付费类型：" :label-width="formLabelWidth" prop="payType">
              <label v-if="detailForm.payType" v-text="detailForm.payType.message"></label>
            </el-form-item>
          </el-col>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="closeDetailForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      detailFormVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/detail.vue